module.exports = __webpack_public_path__ + "img/plan-bg.2b1bc2d5.png";